import { formatAccountSubtype } from '../../utils/accounts';
import { cx } from '../../utils/cx';
import Entity from '../entity';

import type { FinancialAccountSubtype } from '../../__generated__/globalTypes';

interface IFinancialAccountInfo {
  id: string;
  name: string;
  mask: string;
  subtype: FinancialAccountSubtype;
}

interface IBankAccountNameAndAvatarProps {
  financialAccount: IFinancialAccountInfo;
  displayNameClassName?: string;
}

const BankAccountNameAndAvatar = ({ financialAccount, displayNameClassName }: IBankAccountNameAndAvatarProps) => {
  const subtypeLabel = formatAccountSubtype(financialAccount.subtype);
  const secondaryText = `${subtypeLabel} | ••${financialAccount.mask}`;

  return (
    <div className="flex min-w-0 items-center gap-2">
      <Entity.Avatar entity={financialAccount} size="sm" />
      <div className="flex min-w-0 flex-1 flex-col">
        <span className={cx('text-primary min-w-0 truncate text-base font-medium', displayNameClassName)}>
          {financialAccount.name}
        </span>
        <span className="text-tertiary text-sm font-medium">{secondaryText}</span>
      </div>
    </div>
  );
};

export default BankAccountNameAndAvatar;
